export default __webpack_public_path__ + "static/media/1280x500_cam.df1539f3.jpg";